<div class="page-container">
  <app-page-heading [heading]="heading"
                    [hasBackButton]="true"
                    [backPageName]="backPageName"
                    [customRoute]="customRoute"
                    [tabName]="tabName">
  </app-page-heading>

  <div class="stepper-container">
    <mat-horizontal-stepper #stepper [linear]="true">

      <!---------------------------->
      <!-- Step 1: General -->
      <!---------------------------->
      <mat-step [stepControl]="generalFormGroup">
        <ng-template matStepLabel>General</ng-template>
        <form [formGroup]="generalFormGroup">
          <mat-grid-list cols="2" rowHeight="75px">
            <mat-grid-tile>
              <mat-form-field>
                <mat-label>Name</mat-label>
                <input matInput formControlName="name" required
                       (input)="onInputUpdatePageHeading($any($event).target.value)">
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile>
              <mat-form-field>
                <mat-label>Entity Status</mat-label>
                <mat-select formControlName="entityStatus" required>
                  <mat-option *ngFor="let status of entityStatuses" [value]="status.value">
                    {{status.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-grid-tile>

          </mat-grid-list>

          <mat-grid-list cols="2" rowHeight="75px">


            <mat-grid-tile>
              <mat-form-field>
                <mat-label>Broker Number</mat-label>
                <input matInput formControlName="brokerNumber" required>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile>
              <greydom-date-picker
                label="Start Date"
                formControlName="startDate"
                [required]="true"
                [showInfoIcon]="false"
                [tooltip]="getInfoTooltip('Start Date')"
                [maxDate]="generalFormGroup.get('endDate').value">
              </greydom-date-picker>
            </mat-grid-tile>


          </mat-grid-list>

          <mat-grid-list cols="2" rowHeight="75px">
            <mat-grid-tile>
              <mat-form-field>
                <mat-label>Business Type</mat-label>
                <mat-select formControlName="businessType" required>
                  <mat-option *ngFor="let type of businessTypes" [value]="type.value">
                    {{type.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile>
              <greydom-date-picker
                label="End Date"
                formControlName="endDate"
                [showInfoIcon]="false"
                [tooltip]="getInfoTooltip('End Date')"
                [minDate]="generalFormGroup.get('startDate').value">
              </greydom-date-picker>
            </mat-grid-tile>

          </mat-grid-list>

          <mat-grid-list cols="2" rowHeight="100px">
            <mat-grid-tile>
              <mat-form-field>
                <mat-label>Broker Group</mat-label>
                <mat-select formControlName="brokerGroup">
                  <mat-option *ngFor="let group of brokerGroups" [value]="group.value">
                    {{group.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile>
              <button mat-raised-button
                      color="primary"
                      (click)="openUnderwritingConcessionsDialog()"
                      [matTooltip]="getConcessionsTooltip()"
                      [matBadge]="underwritingConcessions.length"
                      matBadgeColor="accent"
                      matBadgePosition="above after">
                <mat-icon>add</mat-icon>
                Add Concessions
              </button>
              <button mat-raised-button
                      color="primary"
                      style="margin-left: 12px"
                      (click)="onClickManagePermissions()"
                      [matTooltip]="'Manage this broker\'s feature access'"
                      [matBadge]="numberOfAllowedFeatures"
                      matBadgeColor="accent"
                      matBadgePosition="above after">
                <mat-icon>edit</mat-icon>
                Manage Permissions
              </button>
            </mat-grid-tile>
          </mat-grid-list>

          <div class="button-container">
            <button mat-raised-button color="warn" (click)="resetGeneralFormGroup()">Clear</button>
            <button mat-raised-button color="primary" matStepperNext>Next</button>
          </div>
        </form>
      </mat-step>

      <!---------------------------->
      <!-- Step 2: Addresses -->
      <!---------------------------->
      <mat-step #addressStep [completed]="addressFormComponent?.selectedAddresses?.length>0">
        <ng-template matStepLabel>Addresses</ng-template>
        <greydom-address-form #addressFormComponent
                              [data]="selectedBroker"></greydom-address-form>
      </mat-step>

      <!---------------------------->
      <!-- Contacts Step -->
      <!---------------------------->

      <mat-step #contactsStep [completed]="contactFormComponent?.selectedContacts?.length>0">
        <ng-template matStepLabel>Contacts</ng-template>
        <greydom-contact-form #contactFormComponent
                              [data]="selectedBroker"></greydom-contact-form>
      </mat-step>

      <!---------------------------->
      <!-- Step 4: Statutory -->
      <!---------------------------->
      <mat-step #statutoryStep [completed]="statutoryFormGroup.valid">
        <ng-template matStepLabel>Statutory</ng-template>
        <form [formGroup]="statutoryFormGroup">
          <mat-grid-list cols="2" rowHeight="75px">
            <mat-grid-tile>
              <mat-form-field>
                <mat-label>Business License Number</mat-label>
                <input formControlName="businessLicenseNumber" type="text" matInput required>
              </mat-form-field>
              <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Business License Number')">help_outline
              </mat-icon>
            </mat-grid-tile>
            <mat-grid-tile class="align-left">
              <label>VAT Applicable</label>
              <mat-radio-group formControlName="vatOverride" aria-label="Select yes OR no">
                <mat-radio-button class="radio-button" style="margin-left: 20px;" [value]="true">Yes</mat-radio-button>
                <mat-radio-button class="m-l-5 radio-button" [value]="false" checked>No</mat-radio-button>
              </mat-radio-group>
              <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('VAT Applicable')">help_outline</mat-icon>
            </mat-grid-tile>
          </mat-grid-list>

          <mat-grid-list cols="2" rowHeight="75px">
            <mat-grid-tile>
              <greydom-date-picker
                label="Business License Expiry Date"
                formControlName="businessLicenseExpiryDate"
                [tooltip]="getInfoTooltip('Business License Expiry Date')">
              </greydom-date-picker>
            </mat-grid-tile>
            <mat-grid-tile *ngIf="statutoryFormGroup.get('vatOverride').value">
              <mat-form-field>
                <mat-label>VAT Number</mat-label>
                <input formControlName="vatNumber" type="text" matInput>
              </mat-form-field>
              <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('VAT Number')">help_outline</mat-icon>
            </mat-grid-tile>
          </mat-grid-list>

          <mat-grid-list cols="2" rowHeight="75px">
            <mat-grid-tile>
              <mat-label style="margin-right: 5px;">License Copy</mat-label>
              <input id="onLicenseFileUpload" type="file" accept="image/jpeg,application/pdf" [disabled]="true"/>
              <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('License Copy')">help_outline</mat-icon>
            </mat-grid-tile>
            <mat-grid-tile>
              <mat-label>GST Applicable</mat-label>
              <mat-radio-group formControlName="gstOverride" aria-label="Select a yes OR no" style="margin-left: 20px;"
              >
                <mat-radio-button class="radio-button" [value]="true">Yes</mat-radio-button>
                <mat-radio-button class="m-l-5 radio-button" [value]="false" checked>No</mat-radio-button>
              </mat-radio-group>
              <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('GST Applicable')">help_outline</mat-icon>
            </mat-grid-tile>
          </mat-grid-list>

          <mat-grid-list cols="2" rowHeight="75px">
            <mat-grid-tile>
              <mat-form-field>
                <mat-label>Sanction Check Reference Number</mat-label>
                <input formControlName="sanctionReference" type="text" matInput>
              </mat-form-field>
              <mat-icon [matTooltip]="getInfoTooltip('Sanction Check Reference Number')" class="info-icon">
                help_outline
              </mat-icon>
            </mat-grid-tile>
            <mat-grid-tile *ngIf="statutoryFormGroup.get('gstOverride').value">
              <mat-form-field>
                <mat-label>GST Number</mat-label>
                <input formControlName="gstNumber" type="text" matInput>
              </mat-form-field>
              <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('GST Number')">help_outline</mat-icon>
            </mat-grid-tile>
          </mat-grid-list>
          <mat-grid-list cols="2" rowHeight="75px">
            <mat-grid-tile>
              <greydom-date-picker
                label="Sanction Check Date"
                formControlName="sanctionCheckDate"
                [tooltip]="getInfoTooltip('Sanction Check Date')">
              </greydom-date-picker>
            </mat-grid-tile>
          </mat-grid-list>

          <div class="button-container">
            <button mat-raised-button color="primary" matStepperPrevious>Back</button>
            <button mat-raised-button color="warn" (click)="resetStatutoryFormGroup()">Clear</button>
            <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="isFinishButtonDisabled()">
              Finish
            </button>
          </div>
        </form>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
